var accordionstatus = [];

const fAccordion = () => {
  const aAccordions = document.querySelectorAll('.js-accordion');

  const fInitAccordion = (oAccordion) => {
    const aTriggers = oAccordion.querySelectorAll('.js-accordion-open');

    aTriggers.forEach((trigger) => {
      const oAccordionContainer = trigger.closest('.js-accordion');
      let oParent = trigger.parentNode;
      let oCollapse = oParent.querySelector('.js-accordion-collapse');
      const oChevron = trigger.querySelector('.icon--chevron');
      let oCollapseHeight = oCollapse.offsetHeight;
      const bOpenOne = (oAccordionContainer.getAttribute('data-accordion-openOne') === 'true');

      oCollapse.style.height = '0px';
      oCollapse.style.position = 'relative';
      oCollapse.style.opacity = 1;
      oCollapse.style.visibility = 'visible';

      if (oParent.id && !oParent.getAttribute('data-accordion-active') && accordionstatus[oParent.id] === true) {
        oParent.setAttribute('data-accordion-active', true);
      }

      if (oParent.getAttribute('data-accordion-active')) {

        if (oParent.id) {
            accordionstatus[oParent.id] = true;
        }

        oCollapse.style.height = null;
        if (oChevron) {
          // Using Attribute here, IE11 Doenst support classList on SVG's
          oChevron.removeAttribute('class', 'accordion__item__icon icon--chevron icon--chevron-down');
          oChevron.setAttribute('class', 'accordion__item__icon icon--chevron icon--chevron-up');
        }
      }

      trigger.addEventListener('click', (e) => {
        e.stopImmediatePropagation();
        if (oParent.getAttribute('data-accordion-active')) {
          oCollapseHeight = oCollapse.offsetHeight;
          oCollapse.style.height = `${oCollapseHeight}px`;

          setTimeout(() => {
            oCollapse.style.height = '0px';
          }, 0);

          if (oChevron) {
            oChevron.removeAttribute('class', 'accordion__item__icon icon--chevron icon--chevron-up');
            oChevron.setAttribute('class', 'accordion__item__icon icon--chevron icon--chevron-down');
          }

          setTimeout(() => {
            oParent.removeAttribute('data-accordion-active');

            if (oParent.id) {
              accordionstatus[oParent.id] = false;
            }

            oCollapse.style.height = null;
            oCollapseHeight = oCollapse.offsetHeight;
            oCollapse.style.height = '0px';
          }, 400);
        } else {
          if (bOpenOne) {
            const oCurrent = oAccordionContainer.querySelector('[data-accordion-active="true"]');

            if (oCurrent) {
              const oCurrentCollapse = oCurrent.querySelector('.js-accordion-collapse');
              const oCurrentChevron = oCurrent.querySelector('.icon--chevron');

              oCurrentCollapse.style.height = '0px';
              oCurrent.removeAttribute('data-accordion-active');

              if (oParent.id) {
                accordionstatus[oParent.id] = false;
              }

              if (oCurrentChevron) {
                oCurrentChevron.removeAttribute('class', 'accordion__item__icon icon--chevron icon--chevron-up');
                oCurrentChevron.setAttribute('class', 'accordion__item__icon icon--chevron icon--chevron-down');
              }
            }
          }

          oCollapse.style.height = `${oCollapseHeight}px`;
          oParent.setAttribute('data-accordion-active', true);

          if (oParent.id) {
            accordionstatus[oParent.id] = true;
          }

          var isFaqPage = document.querySelector('.js-faq-page');
          if (isFaqPage) {
             var hdr = oParent.querySelector('.accordion__item__header');
             if (hdr) {
               var txt = hdr.querySelector('h3');
               if (txt) {
                 window.dataLayer = window.dataLayer || [];
                 dataLayer.push({
                    'event': 'faq_open_question',
                    'faq_question': txt.innerHTML
                 });
               }
             }
          }

          if (website.iScreenWidth < website.mobileBreakpoint) {
              window.scrollTo(0, (oParent.getBoundingClientRect().top - oParent.getBoundingClientRect().height) + window.scrollY);

              if (oParent.parentElement.classList.contains('accordion--info')) {
                oParent.scrollIntoView({ block: "start", inline: "nearest" });
              }
          }

          setTimeout(() => {
                oCollapse.style.height = '';
                oCollapseHeight = oCollapse.offsetHeight;

                var configuratorfilters = document.querySelector('.configuratorfilters');
                var filters = document.querySelector('.filters');
                if (filters || configuratorfilters) {
                    if (!oCollapse.parentElement.parentElement.classList.contains("filters__mobile__list")) {
                        oCollapse.parentElement.scrollIntoView({ block: "nearest", inline: "nearest" });
                    } else if (configuratorfilters) {
                        oCollapse.parentElement.scrollIntoView({ block: "nearest", inline: "nearest" });
                    }
                }

          }, 400);

          if (oChevron) {
            oChevron.removeAttribute('class', 'accordion__item__icon icon--chevron icon--chevron-down');
            oChevron.setAttribute('class', 'accordion__item__icon icon--chevron icon--chevron-up');
          }
        }
      });

      window.onresize = () => {
        for (let t = 0; t < aTriggers.length; t += 1) {
          oParent = aTriggers[t].parentNode;
          oCollapse = oParent.querySelector('.js-accordion-collapse');

          if (oParent.getAttribute('data-accordion-active')) {
            oCollapse.style.height = null;
          }

          oCollapseHeight = oCollapse.offsetHeight;
        }
      };

      oAccordionContainer.classList.add('is-loaded');
    });
  };

  for (let a = 0; a < aAccordions.length; a += 1) {
    fInitAccordion(aAccordions[a]);
  }
};
